import React, { Attributes, FC } from "react";
import cn from "classnames";

import { Form, InputNumber } from "rsuite";
import { FormControlProps } from "rsuite/esm/FormControl/FormControl";

import "../Form.less";

export interface Props extends FormControlProps, Attributes {
    title?: string;
    helpText?: string;
}

const Group: FC<Props> = ({ key, helpText, title, ...props }: Props) => {
    return (
        <Form.Group key={key} {...props}>
            <Form.ControlLabel className={"data-import_settings-groups__label"}>
                {title}
                <Form.HelpText
                    className={"data-import_settings-groups__help"}
                    tooltip
                >
                    {helpText}
                </Form.HelpText>
            </Form.ControlLabel>

            <Form.Control
                {...props}
                accepter={InputNumber}
                className={cn(
                    "data-import_settings-groups__form__control",
                    "data-import_settings-groups__input--long"
                )}
            />
        </Form.Group>
    );
};

export default Group;
